import { useContext, useState } from 'react'
import { StoreContext } from '~/store'
import { emitCustomEvent } from 'react-custom-events'
import { useTranslation } from 'react-i18next'
import { Modal, ButtonDrawer, AddAccount } from '~/components'
import { showContentModal } from '~/lib/modal'
import * as styles from './index.module.css'

const CardIllustration = () => (
  <div className={styles.illustration}>
    <div className={styles.mapCircle} />
    <svg className={styles.card} width="123" height="75" viewBox="0 0 123 75" fill="none" aria-hidden="true">
      <rect width="123" height="75" rx="8" fill="#1E2029" />
      <rect y="15" width="123" height="10" fill="#F0EFEB" fillOpacity="0.15" />
      <rect x="10" y="48" width="72" height="7" rx="3" fill="#F0EFEB" fillOpacity="0.15" />
      <rect x="10" y="38" width="52" height="5" rx="3" fill="#F0EFEB" fillOpacity="0.15" />
    </svg>
    <div className={styles.plusBadge}>
      <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
        <path d="M9 3v12M3 9h12" stroke="white" strokeWidth="2" strokeLinecap="round" />
      </svg>
    </div>
  </div>
)

const CardIcon = () => (
  <div className={styles.rowIcon}>
    <svg width="26" height="19" viewBox="0 0 26 19" fill="none" aria-hidden="true">
      <rect width="26" height="19" rx="4" fill="#1e2029" />
      <rect y="4" width="26" height="5" fill="rgba(240,239,235,0.25)" />
      <rect x="3" y="12" width="12" height="3" rx="1.5" fill="rgba(240,239,235,0.35)" />
    </svg>
  </div>
)

const ChevronRight = () => (
  <svg width="8" height="14" viewBox="0 0 8 14" fill="none" aria-hidden="true">
    <path d="M1 1l6 6-6 6" stroke="#17181a" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
)

export default function AddPaymentMethodModal() {
  const { t } = useTranslation()
  const { user, showAddPaymentModal, setShowAddPaymentModal, refreshUser } = useContext(StoreContext)
  const [showSelector, setShowSelector] = useState(false)

  if (!showAddPaymentModal) return null
  if (user?.shouldConsentToMarketing) return null

  const dismiss = () => {
    setShowAddPaymentModal(false)
    setShowSelector(false)
  }

  const handleSelectCard = () => {
    dismiss()
    emitCustomEvent('CASHIER_ADD_CARD', { success: refreshUser })
  }

  const handleSelectAccount = () => {
    dismiss()
    showContentModal((close) => <AddAccount onComplete={() => { close(); refreshUser() }} />)
  }

  return (
    <Modal isOpen rounded>
      {!showSelector ? (
        <>
          <div className={styles.content}>
            <CardIllustration />
            <div className={styles.text}>
              <p className={styles.title}>{t('add-payment-title')}</p>
              <p className={styles.body}>{t('add-payment-body')}</p>
            </div>
          </div>
          <ButtonDrawer buttons={[
            { func: () => setShowSelector(true), title: t('add-payment-button') },
            { func: dismiss, title: t('add-payment-not-now') },
          ]} modal />
        </>
      ) : (
        <>
          <div className={styles.selectorContent}>
            <p className={styles.selectorTitle}>{t('add-payment-title')}</p>
              <div className={styles.selectorList}>
                <button className={styles.selectorRow} onClick={handleSelectCard}>
                  <CardIcon />
                  <span className={styles.selectorRowLabel}>{t('add-payment-type-card')}</span>
                  <ChevronRight />
                </button>
                <button className={styles.selectorRow} onClick={handleSelectAccount}>
                  <div className={styles.rowIcon}>
                    <img
                      src="/app/themes/taxi-stockholm/static/img/option-icons/TSAB.png"
                      alt=""
                      className={styles.rowIconImg}
                    />
                  </div>
                  <span className={styles.selectorRowLabel}>{t('add-payment-type-tsab')}</span>
                  <ChevronRight />
                </button>
              </div>
          </div>
          <ButtonDrawer buttons={[
            { func: () => setShowSelector(false), title: t('button-back') },
            { func: dismiss, title: t('add-payment-not-now') },
          ]} modal />
        </>
      )}
    </Modal>
  )
}
